import Box from '@mui/material/Box'
import adminModern from '../../svg/modernIcons/adminModern.svg'
import adminBoxy from '../../svg/boxyIcons/adminBoxy.svg'
import UserManagement from '../UserManagement'
import React from 'react'
import Setting from '../Setting'

const AdminIcon = () => {
    const iconSelect = localStorage.getItem('iconsSelect')
    const icon = iconSelect === 'Custom'
        ? <UserManagement />
        : iconSelect === 'Boxy'
            ? <img src={adminBoxy} alt='Admin' />
            : iconSelect === 'Modern'
                ? <img src={adminModern} alt='Admin' />
                : <Setting />

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                marginRight: '5px',
                width: '25px',
                '& svg': { maxHeight: '24px', width: '30px' }
            }}
        >
            {icon}
        </Box>
    )
}

export default AdminIcon
